const Data = {
  ru: 'Позвони нам',
  en: 'CALL US',
  ua: "Подзвони нам"
};

export default Data;
